import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./i18n"; // 🆕
import "./index.css";

console.log("🚀 Starting React app...");

const rootElement = document.getElementById("root");
console.log("Root element:", rootElement);

if (rootElement) {
  console.log("✅ Root element found, rendering app...");
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  console.log("✅ App rendered successfully");
} else {
  console.error("❌ Root element not found!");
}
